<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row class="align-center">
      <v-col
        v-for="(item, index) in items"
        :key="index"
        sm="auto"
      >
        <v-checkbox
          :key="'m' + index"
          :label="item.name.toUpperCase()"
          :input-value="item.is_active"
          @click="submit(item)"
        />
      </v-col>
      <v-col class="text-end">
        <a href="https://app.powerbi.com/groups/b21fb517-8ca2-4267-8963-23ca228bc885/list?experience=power-bi">POWER BI URL</a>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span style="font-size: 16px; font-weight: bold;">User Access</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="users"
            :footer-props="footer"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.full_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.full_name }}
              </text-highlight>
            </template>
            <template #[`item.roles`]="{ item }">
              <v-row v-if="item.roles && item.roles.length > 1">
                <v-col class="pl-1">
                  <v-tooltip
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span
                        style="color: #1976d2;"
                        v-on="on"
                      >ROLES</span>
                    </template>
                    <span
                      v-for="p in item.roles"
                      :key="p.id"
                    >
                      {{ p.name }}<br>
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col
                  v-for="p, idx in item.roles"
                  :key="p.id"
                  cols="auto"
                  class="pr-0 pl-1"
                >
                  <span>
                    {{ p.name }}<span v-if="idx !== item.roles.length - 1">,</span>
                  </span>
                </v-col>
              </v-row>
            </template>

            <template #[`item.glass_purchase_order`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(glassPurchseOrderId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, glassPurchseOrderId)"
              />
            </template>
            <template #[`item.glass_quality`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(glassQuantityId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, glassQuantityId)"
              />
            </template>
            <template #[`item.glass_sheets`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(glassSheetId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, glassSheetId)"
              />
            </template>
            <template #[`item.windows`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(windowsId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, windowsId)"
              />
            </template>
            <template #[`item.windows_history`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(windowsHistoryId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, windowsHistoryId)"
              />
            </template>
            <template #[`item.windows_asset_history`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(windowsAssetHistoryId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, windowsAssetHistoryId)"
              />
            </template>
            <template #[`item.shipping_accuracy`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(shippingAccuracyId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, shippingAccuracyId)"
              />
            </template>
            <template #[`item.awd_breakdown`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(awdBreakdownId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, awdBreakdownId)"
              />
            </template>
            <template #[`item.paint_consumption`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(awdPaintConsumptionId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, awdPaintConsumptionId)"
              />
            </template>
            <template #[`item.procore_correspondence`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(procoreCorrespondenceId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, procoreCorrespondenceId)"
              />
            </template>
            <template #[`item.procore_rfi`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(procoreActivityTrackerId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, procoreActivityTrackerId)"
              />
            </template>
            <template #[`item.filedwire_tickets_summary`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(fieldwireTicketSummary)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, fieldwireTicketSummary)"
              />
            </template>
            <template #[`item.fieldwire_project_tasks`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(fieldwireProjectTasksId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, fieldwireProjectTasksId)"
              />
            </template>
            <template #[`item.consumables`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(consumablesId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, consumablesId)"
              />
            </template>
            <template #[`item.windows_in_quarantine`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(windowsInQuarantineId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, windowsInQuarantineId)"
              />
            </template>
            <template #[`item.panels`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(panelsId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, panelsId)"
              />
            </template>
            <template #[`item.commercial_dashboard`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(commercialDashboardId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, commercialDashboardId)"
              />
            </template>
            <template #[`item.otd`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(otdId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, otdId)"
              />
            </template>
            <template #[`item.inspection`]="{ item }">
              <v-checkbox
                v-if="item.dashboard_ids"
                :input-value="item.dashboard_ids.includes(inspectionId)"
                hide-details
                class="mt-0"
                @change="handleCheckboxChange($event, item, inspectionId)"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
  },
  data: () => ({
    items: [],
    users: [],
    headers: [
      { text: 'User', value: 'full_name' },
      { text: 'Roles', value: 'roles' },
      { text: 'Glass', value: 'glass_purchase_order' },
      { text: 'Glass Quality', value: 'glass_quality' },
      { text: 'Glass Sheets', value: 'glass_sheets' },
      { text: 'Windows', value: 'windows' },
      { text: 'Windows History', value: 'windows_history' },
      { text: 'Windows Asset History', value: 'windows_asset_history' },
      { text: 'Shipping Accuracy', value: 'shipping_accuracy' },
      { text: 'Breakdown', value: 'awd_breakdown' },
      { text: 'Paint Consumption', value: 'paint_consumption' },
      { text: 'Fieldwire Tasks', value: 'procore_correspondence' },
      { text: 'Filedwire Tickets Summary', value: 'filedwire_tickets_summary' },
      { text: 'Fieldwire Project Tasks', value: 'fieldwire_project_tasks' },
      { text: 'Consumables', value: 'consumables' },
      { text: 'Windows in Quarantine', value: 'windows_in_quarantine' },
      { text: 'Panels', value: 'panels' },
      { text: 'Commercial Dashboard', value: 'commercial_dashboard' },
      { text: 'OTD', value: 'otd' },
      { text: 'Inspections', value: 'inspection' },
      // { text: 'Procore RFI', value: 'procore_rfi' },
      // { text: '300 Chrislea Inventory', value: 'chrislea_inventory' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
    glassPurchseOrderId: 1,
    chrisleaInventoryId: 2,
    procoreCorrespondenceId: 3,
    awdBreakdownId: 4,
    awdPaintConsumptionId: 5,
    windowsId: 6,
    glassQuantityId: 7,
    windowsHistoryId: 8,
    shippingAccuracyId: 9,
    glassSheetId: 10,
    procoreActivityTrackerId: 11,
    windowsAssetHistoryId: 12,
    fieldwireTicketSummary: 13,
    fieldwireProjectTasksId: 14,
    consumablesId: 15,
    windowsInQuarantineId: 16,
    panelsId: 17,
    commercialDashboardId: 18,
    otdId: 19,
    inspectionId: 20,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  watch: {
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get();
      this.getUsers();
    },

    async submit(item) {
      const record = item;
      record.is_active = !item.is_active;
      const res = await this.$api.dashboards.store(record);
      if (!res) {
        this.$bus.$emit('showError');
      }
    },

    async get() {
      this.items = await this.$api.dashboards.get();
    },

    async getUsers() {
      this.loading = true;
      const submitModel = {
        filters: {
        },
      };
      this.users = await this.$api.dashboards.read(submitModel, null, 'read/users');
      this.loading = false;
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async handleCheckboxChange(isChecked, item, id) {
      if (isChecked) {
        item.dashboard_ids.push(id);
      } else {
        const index = item.dashboard_ids.indexOf(id);
        if (index !== -1) {
          item.dashboard_ids.splice(index, 1);
        }
      }

      const submitModel = {
        user_id: item.id,
        dashboard_ids: item.dashboard_ids,
      };

      const res = await this.$api.dashboards.update(submitModel, 'user-dashboard');

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.getUsers();
    },
  },
};
</script>
